export default "__VITE_ASSET__DaPNoKW7__"